import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  Typography,
  TextField
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinkIcon from "@mui/icons-material/Link";
import KeyIcon from "@mui/icons-material/Key";
import { GenerateCredentialsButton,NameAllocatedButoon, GoToMessageButton,AllocateButton } from "../../Global_Component/GlobalButtonComponent";
import { CustomSecondaryEditButton } from "../../Global_Component/GlobalButtonComponent";
import { EditableTextField,SearchBar } from "../../Global_Component/CustomInputComponent";
import UserProfileService from "../../services/Profile.services";
const rows = [
  { id: 1, name: "Atif Khan",login:"10:10 pm",industryType:"Food",logOut:"8:05 pm",status:"completed", hours: "8h 20m", inquiry: "Halal certificate" },
  { id: 2, name: "Talan Curtis",login:"10:10 pm",industryType:"Food",logOut:"8:05 pm",status:"completed", hours: "8h 20m", inquiry: "Medical tourism assistance" },
  { id: 3, name: "Kadin Geidt",login:"10:10 pm",industryType:"Food",logOut:"8:05 pm",status:"completed", hours: "8h 20m", inquiry: "Halal certificate" },
  { id: 4, name: "Ahmed Khan",login:"10:10 pm",industryType:"Food",logOut:"8:05 pm",status:"completed", hours: "8h 20m", inquiry: "Halal certificate" },
  { id: 5, name: "Jakob Bergson",login:"10:10 pm",industryType:"Food",logOut:"8:05 pm",status:"completed", hours: "8h 20m", inquiry: "Medical tourism assistance" },
];

const ResultTable = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [filter, setFilter] = useState({ role: ["CLIENT"] });

  const [tableData, setTableDate] = useState([]);

  async function fetchCompany(params) {
    
    const response = await UserProfileService.getAllUser(filter);
    console.log("response", response.data);
    setTableDate(response?.data);
  }

  useEffect(() => {
    fetchCompany();
  }, [filter]);

  return (
 <>

<Grid container spacing={0} sx={{display:"flex",p:2,alignItems:'center',justifyContent:"space-between",bgcolor:"#FFFFFF"}}>
<Grid sm={3} >
     <Typography variant="body2"   sx={{color:"#0072DA",fontWeight:"500",borderBottom:"3px solid #0072DA",paddingBottom:2}} color="initial">Employee Attendance</Typography>
   </Grid>

   <Grid sm={5} sx={{mx:1}}>
       <SearchBar
       name="search"
         id=""
         onChange={e=>{setFilter({...filter,[e.target.name]:e.target.value})}}
         placeholder="Search for User"  
       />
   </Grid>
  
</Grid>   

    <TableContainer
    component={Paper}
    sx={{
        borderRadius: 2,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        overflowX: "auto", // Enable horizontal scrolling
        width: "100%", // Full-width container
        "&::-webkit-scrollbar": {
          height: "6px", // Thin scrollbar height
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#B0BEC5", // Color of the scrollbar thumb
          borderRadius: "3px", // Rounded edges for thumb
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#F5F5F5", // Background track color
        },
        scrollbarWidth: "thin", // For Firefox
        scrollbarColor: "#B0BEC5 #F5F5F5", // Thumb and track colors for Firefox
      }}
  >
    <Table
      sx={{
      
        minWidth: "100%", // Set a minimum width for the table
        flexWrap:"wrap"
      }}
    >
      {/* Table Header */}
      <TableHead sx={{ bgcolor: "#F6F8FA" }}>
        <TableRow>
          <TableCell
            sx={{ fontWeight: 500, color: "#616161", textAlign: "center" }}
          >
            #
          </TableCell>
          <TableCell
            sx={{ fontWeight: 500, color: "#616161", width: "200px" }}
          >
            Employee Name
          </TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>LogIn</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>LogOut</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>Department</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>
          Hours
          </TableCell>
         
          <TableCell
            sx={{
              fontWeight: 500,
              color: "#616161",
              textAlign: "right",
            }}
          >
            Actions
          </TableCell>
        </TableRow>
      </TableHead>
  
      {/* Table Body */}
      <TableBody>
        {tableData.map((row, index) => (
          <TableRow key={row.id}>
            {/* ID */}
            <TableCell>{index + 1}</TableCell>
  
            {/* Name with Avatar */}
            <TableCell
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Avatar
              src="https://designimages.appypie.com/profilepicture/profilepicture-1-head-person.jpg"
                sx={{
                  bgcolor: index % 2 === 0 ? "#FFEBEE" : "#E3F2FD",
                  color: index % 2 === 0 ? "#D32F2F" : "#1976D2",
                  fontWeight: 500,
                  width: 40,
                  height: 40,
                  fontSize: 14,
                }}
              >
                
              </Avatar>
              <span style={{ marginLeft: 10, fontWeight: 500 }}>{row.firstName +" "+row.lastName}</span>
            </TableCell>
  
            {/* Other Columns */}
            <TableCell sx={{ color: "green" }}>
              {index%3==0?"10 : 12 am":"10 : 20 am"}
            </TableCell>
            <TableCell sx={{ color: "red" }}> {index%3==0?"7 : 02 pm":"7 : 30 pm"}</TableCell>
            <TableCell sx={{ color: "#374151" }}>{row.role!="CLIENT"?row.role:"CRM"}</TableCell>
            <TableCell sx={{ color: "#374151" }}>{index%3==0?"8h 30 min":"8h 0 min"}</TableCell>
          
  
            {/* Actions */}
            <TableCell sx={{p:0}}>
              <GoToMessageButton userId={row._id}  label="Message"  />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
 </>
  );
};

export default ResultTable;
